<template>
  <div class="mx-3 py-2 justify-content-start">
    <label for="master-incomes" class="form-label col-md-12 p-0 size-12 lh-12">希望年収</label>
    <div class="p-0 m-0 d-flex flex-column gap-3">
      <div class="mb-2 mb-md-0 p-0 w-100">
        <div class="d-flex align-items-center gap-2">
          <Field v-slot="{ field }" v-model="localMinIncome" name="min_income_id">
            <select
              class="form-select select-input-primary size-14 lh-14"
              aria-label="master-icome-label"
              v-bind="field"
              @change="handleMinIncomeChange"
            >
              <option value="">最低年収</option>
              <option v-for="income in props.incomes" :key="income.id" :value="income.id">
                {{ income.display_amount }}
              </option>
            </select>
          </Field>
          <div class="flex-grow-1 size-12 text-nowrap">以上</div>
        </div>
      </div>
      <div class="p-0 w-100">
        <div class="d-flex align-items-center gap-2">
          <Field v-slot="{ field }" v-model="localMaxIncome" name="max_income_id">
            <select
              class="form-select select-input-primary size-14 lh-14"
              aria-label="master-icome-label"
              v-bind="field"
              @change="handleMaxIncomeChange"
            >
              <option value="">最高年収</option>
              <option v-for="income in props.incomes" :key="income.id" :value="income.id">
                {{ income.display_amount }}
              </option>
            </select>
          </Field>
          <div class="flex-grow-1 size-12 text-nowrap">以下</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits, ref, watch } from 'vue';
import { Field } from 'vee-validate';
import { IncomePrimary } from '@/types/models/income';

interface Props {
  minIncome: number | null;
  maxIncome: number | null;
  incomes: IncomePrimary[];
}

const props = defineProps<Props>();

const emit = defineEmits(['changeMin', 'changeMax']);

// ローカル状態の管理
const localMinIncome = ref<number | null>(props.minIncome);
const localMaxIncome = ref<number | null>(props.maxIncome);

// propsの変更を監視
watch(
  () => props.minIncome,
  (newValue) => {
    localMinIncome.value = newValue;
  }
);

watch(
  () => props.maxIncome,
  (newValue) => {
    localMaxIncome.value = newValue;
  }
);

const handleMinIncomeChange = (): void => {
  emit('changeMin', { value: localMinIncome.value });
};

const handleMaxIncomeChange = (): void => {
  emit('changeMax', { value: localMaxIncome.value });
};
</script>
